module.exports = __webpack_public_path__ + "static/media/moment09.60603ea4.webp";